import { useContext, useEffect, useState } from "react";
import { toast, Zoom } from "react-toastify";
import { useNavigate } from "react-router-dom";
// import { NotificationsContext } from "@notifications/context";
// import { NotificationsService } from "@consumers/services";
import NotificationWizardView from "./view";
import style from "./style";
import { AppContext } from "@client/shared/contexts";
import { DELIVERY_TYPE } from "@client/shared/constants";
import Service from "../service";
const NotificationWizard = () => {
  const [state, setState] = useState({
    currentSection: 0,
    isCreating: false,
    values: null,
    isParsingPhoneNumber: false,
    isPhoneNumberParsed: false,
    validationError: false,
  });
  const isTriggerTypeVoicemail = !!state.values?.voicemail_extensions;
  const navigation = useNavigate();
  const { appData, setAppData } = useContext(AppContext);
  const isSectionComplete = (section) => {
    let isComplete = true;
    const currentValues = state.values;
    if (!currentValues) {
      return false;
    }

    switch (section) {
      case 0:
        return (
          !!(currentValues.name || "").trim() && currentValues.name.length < 101
        );
      case 1:
        return currentValues.isExtensionNumber
          ? !!currentValues.extensionNumber &&
              !currentValues.extensionNumberError
          : (!!currentValues.externalNumber &&
              !currentValues.externalNumberError &&
              state.isPhoneNumberParsed) ||
              !!currentValues.voicemail_extensions;
      case 2:
        return !!currentValues.callDirection;
      case 3:
        isComplete = true;
        if (!!currentValues.voicemail_extensions) {
          return isComplete;
        }
        if (
          !currentValues.switches.users &&
          !currentValues.switches.extensionPattern &&
          !currentValues.switches.siteExtensions
        ) {
          return false;
        }

        if (currentValues.switches.users) {
          if (!currentValues.switches.allUsers) {
            if (!currentValues.triggers.users.length) {
              isComplete = false;
            }
          }
        }

        if (currentValues.switches.extensionPattern) {
          if (
            !currentValues.triggers.extensionPattern.length ||
            currentValues.triggers.extensionPattern.length > 300
          ) {
            isComplete = false;
          }
        }

        if (currentValues.switches.siteExtensions) {
          if (!currentValues.triggers.sites.length) {
            isComplete = false;
          }
        }

        return isComplete;
      case 4:
        isComplete = true;
        if (!currentValues.switches.sendImmediate) {
          const isMessageRequired = (currentValues.deliverySteps || [])
            .filter((item) => !item.isDeleted)
            .some((item) => {
              return (
                item.type === DELIVERY_TYPE.EMAIL ||
                item.type === DELIVERY_TYPE.SMS ||
                item.type === DELIVERY_TYPE.GLIP
              );
            });
          if (!currentValues.delivery.message && isMessageRequired) {
            return false;
          }
          return (currentValues.deliverySteps || [])
            .filter((item) => !item.isDeleted)
            .some((item) => {
              return (
                item.type === DELIVERY_TYPE.EMAIL ||
                item.type === DELIVERY_TYPE.SMS ||
                item.type === DELIVERY_TYPE.WEBHOOK ||
                item.type === DELIVERY_TYPE.GLIP ||
                item.type === DELIVERY_TYPE.RINGOUT
              );
            });
        }
        if (
          !currentValues.switches.email &&
          !currentValues.switches.webhook &&
          !currentValues.switches.ringCentralApp &&
          !currentValues.switches.sms &&
          !currentValues.switches.ringout
        ) {
          return false;
        }

        if (currentValues.switches.email) {
          if (
            !currentValues.delivery.email ||
            currentValues.delivery.email.length > 500
          ) {
            isComplete = false;
          }
        }

        // if (currentValues.switches.webhook) {
        //   if (
        //     !currentValues.delivery.webhook.length ||
        //     currentValues.delivery.webhook.length > 500 ||
        //     currentValues.delivery.isJsonError
        //   ) {
        //     isComplete = false;
        //   }
        // }
        if (currentValues.switches.webhook) {
          if (!currentValues.delivery.webhooks.length) {
            isComplete = false;
          }
        }

        if (currentValues.switches.ringCentralApp) {
          if (!currentValues?.delivery?.ringCentralTeams?.length) {
            isComplete = false;
          }
        }

        if (currentValues.switches.sms) {
          if (
            !currentValues.delivery.sms ||
            currentValues.delivery.sms.length > 500
          ) {
            isComplete = false;
          }
        }

        const isMessageOptional =
          !currentValues.switches.email &&
          !currentValues.switches.ringCentralApp &&
          !currentValues.switches.sms;

        if (!currentValues.delivery.message && !isMessageOptional) {
          isComplete = false;
        }

        if (currentValues.switches.ringout) {
          if (
            !currentValues.delivery.ringout?.extension ||
            !currentValues.delivery.ringout?.extensionPhoneNumber ||
            !currentValues.delivery.ringout?.phoneNumber ||
            !!(currentValues.delivery.ringout?.phoneNumberError || "").trim()
          ) {
            isComplete = false;
          }
        }

        return isComplete;
      default:
        return (
          isSectionComplete(0) &&
          isSectionComplete(1) &&
          isSectionComplete(2) &&
          isSectionComplete(3) &&
          isSectionComplete(4)
        );
    }
  };
  const notificationOnChange = (event) => {
    setState((prevState) => ({ ...prevState, values: event }));
  };
  const onParsingPhoneNumber = (value) =>
    setState((prevState) => ({
      ...prevState,
      isParsingPhoneNumber: value,
    }));

  const onPhoneNumParsedSuccess = (value) => {
    setState((prevState) => ({
      ...prevState,
      isPhoneNumberParsed: value,
    }));
  };
  const onClickB1 = (event) => {
    if (state.currentSection > -1) {
      setState((prevState) => ({
        ...prevState,
        currentSection:
          isTriggerTypeVoicemail && prevState.currentSection === 4
            ? prevState.currentSection - 2
            : prevState.currentSection - 1,
      }));
    }
  };

  const onClickB2 = (event) => {
    if (state.currentSection < 5) {
      setState((prevState) => ({
        ...prevState,
        currentSection:
          isTriggerTypeVoicemail && prevState.currentSection === 2
            ? prevState.currentSection + 2
            : prevState.currentSection + 1,
      }));
    }
  };

  const hasValidationError = (value) => {
    setState((prevState) => ({
      ...prevState,
      validationError: !!value,
    }));
  };

  function getSkippedElements(elements, startIndex, endIndex) {
    return elements
      .slice(startIndex, endIndex)
      .filter((element) => element.isDeleted).length;
  }

  const handleFormSubmit = async () => {
    const { values } = state;
    const hasDeliveryVoiceRead = (values.deliverySteps || []).some(
      (item) => item.type === DELIVERY_TYPE.VOICEMAIL_READ_CONDITION,
    );
    if (hasDeliveryVoiceRead && !values.isVoicemailExtensions) {
      return toast.error(
        "Check voicemail condition can only be use for voicemail extension notifications.",
      );
    }
    toast.info("Saving notification, please wait.", {
      autoClose: 2000,
    });

    const timeout = setTimeout(() => {
      toast.info("It is taking longer than expected, please wait.", {
        autoClose: 5000,
        transition: Zoom,
      });
    }, 6000);

    setState((prevState) => ({ ...prevState, isCreating: true }));
    const [webhookPayload, webhookHeader] = (
      values.delivery.webhooks || []
    ).reduce(
      (acc, item) => {
        if (Object.keys(item.json || {}).length) {
          acc[0].push({
            ...item.json,
            __webhookAddress: item.webhook,
          });
        }
        if ((item.headers || []).length) {
          item.headers = item.headers.map((header) => ({
            ...header,
            __webhookAddress: item.webhook,
          }));
          acc[1].push(...item.headers);
        }
        return acc;
      },
      [[], []],
    );

    const { data, error } = await Service.create({
      name: values.name,
      call_direction: values.callDirection,
      external_phone_number:
        values.isVoicemailExtensions || values.isExtensionNumber
          ? null
          : values.externalNumber,
      extension_id: values.isVoicemailExtensions
        ? values.voicemail_extensions?.id
        : values.isExtensionNumber
          ? values.extensionNumber?.id
          : null,
      extension_number: values.isExtensionNumber
        ? values.extensionNumber?.extensionNumber
        : null,
      voicemail_extension: values.isVoicemailExtensions
        ? values.voicemail_extensions?.extensionNumber
        : null,
      is_extension_number: values.isExtensionNumber,
      users: values.switches.users
        ? values.switches.allUsers
          ? "All Users"
          : values.triggers.users.map((user) => user.id).join(",")
        : null,
      extension_patterns: values.switches.extensionPattern
        ? values.triggers.extensionPattern
        : null,
      extension_sites: values.switches.siteExtensions
        ? values.triggers.sites.map((site) => site.name).join(",")
        : null,
      emails: values.switches.sendImmediate
        ? values.switches.email
          ? values.delivery.email
          : null
        : null,
      timezone: values?.delivery?.selectedTimezone || null,
      webhook: values.switches.sendImmediate
        ? values.switches.webhook
          ? values.delivery.webhooks.map(({ webhook }) => webhook).join(",")
          : null
        : null,
      glip_teams: values.switches.sendImmediate
        ? values.switches.ringCentralApp
          ? values.delivery.ringCentralTeams
          : null
        : null,
      sms_to: values.switches.sendImmediate
        ? values.switches.sms
          ? values.delivery.sms
          : null
        : null,

      ringout_extension: values.switches.sendImmediate
        ? values.switches.ringout
          ? values.delivery.ringout?.extension?.id
          : null
        : null,
      ringout_to_number: values.switches.sendImmediate
        ? values.switches.ringout
          ? values.delivery.ringout?.extensionPhoneNumber?.phoneNumber
          : null
        : null,
      ringout_from_number: values.switches.sendImmediate
        ? values.switches.ringout
          ? values.delivery.ringout?.phoneNumber
          : null
        : null,
      sms_from: values.switches.sendImmediate
        ? values.switches.sms
          ? values.delivery.sms_from || null
          : null
        : null,
      message: values.delivery.message,
      payload: values.switches.sendImmediate
        ? values.switches.webhook && webhookPayload.length
          ? webhookPayload
          : null
        : null,
      headers: values.switches.sendImmediate
        ? values.switches.webhook && webhookHeader.length
          ? webhookHeader
          : null
        : null,
      sendImmediate: values.switches.sendImmediate,
      is_immediate: values.switches.sendImmediate,
      delayConfig: (values.deliverySteps || []).map((item) => {
        if (item.type === "delay" && item.delayUnit === "min") {
          delete item.valueParsed;
          return {
            ...item,
            value: item.value * 60,
          };
        }
        if (item.type === "ringout") {
          item.value = {
            ringout_extension: item.value?.extension?.id,
            ringout_to_number: item.value?.extensionPhoneNumber?.phoneNumber,
            ringout_from_number: item.value?.phoneNumber,
          };
        }
        return item;
      }),
    });
    clearTimeout(timeout);
    setState((prevState) => ({ ...prevState, isCreating: false }));
    if (error) {
      toast.error(Array.isArray(error) && error[0] && error[0].message);
    } else {
      toast.success("Notification saved successfully.");
      navigation(`/notifications/${data.notification.id}/edit`);
    }
  };

  const handleNewTeamCreated = (team = {}) => {
    setAppData("teams", [...(appData?.teams || []), team]);
  };

  return (
    <NotificationWizardView
      values={state.values}
      currentSection={state.currentSection}
      isCreating={state.isCreating}
      isParsingPhoneNumber={state.isParsingPhoneNumber}
      isPhoneNumberParsed={state.isPhoneNumberParsed}
      isSectionComplete={isSectionComplete}
      handleFormSubmit={handleFormSubmit}
      notificationOnChange={notificationOnChange}
      onParsingPhoneNumber={onParsingPhoneNumber}
      onPhoneNumParsedSuccess={onPhoneNumParsedSuccess}
      onClickB1={onClickB1}
      onClickB2={onClickB2}
      countries={appData.countries}
      teams={appData.teams}
      sites={appData.sites}
      loadedSites={appData.loadedSites}
      loadedUsers={appData.loadedUsers}
      loadedCountries={appData.loadedCountries}
      loadedTeams={appData.loadedTeams}
      users={appData.users}
      hasValidationError={hasValidationError}
      validationError={state.validationError}
      loadedExtension={appData.loadedExtension}
      onNewTeamCreated={handleNewTeamCreated}
      isTriggerTypeVoicemail={isTriggerTypeVoicemail}
    />
  );
};

export default NotificationWizard;
